import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const Viewer = (props: any) => {
    function getFileExtension(filename) {
        var ext = /^.+\.([^.]+)$/.exec(filename);
        return ext == null ? "" : ext[1];
    }
    let sourceFileExt = getFileExtension(props.docs.url);
    let sourceFile = props.docs.url
        ? props.docs.url
        : "https://requirementsolicitation.blob.core.windows.net/requirement-solicitation/19b2ba5f8/input/Transcript2_Request for setting up a new D365 tenant_2024.08.06 - Copy.docx";
    let docs = [{ uri: props.docs.url }];

    if (sourceFileExt === "pdf") {
        //use object tag for pdfs because iframe does not support page numbers
        return <object data={sourceFile + "#page=1"} type="application/pdf" width="100%" height={"100%"} />;
    } else {
        return (
            <iframe
                title="Source File"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                src={
                    "https://view.officeapps.live.com/op/embed.aspx?src=" +
                    sourceFile +
                    "&action=embedview&amp;wdStartOn=1&amp;wdPrint=1&amp;wdEmbedCode=1&amp;"
                }
                width="100%"
                height="100%"
            />
        );
    }
};
export default Viewer;
